var map = {
	"./chapter-10.yml": [
		460,
		9
	],
	"./chapter-13.yml": [
		461,
		9
	],
	"./chapter-7.yml": [
		462,
		9
	],
	"./cognitive-dissonance.yml": [
		463,
		9
	],
	"./social-psych-12.manifest": [
		339,
		3
	],
	"./social-psych-12.manifest.json": [
		339,
		3
	],
	"./social-psych-14.manifest": [
		340,
		3
	],
	"./social-psych-14.manifest.json": [
		340,
		3
	],
	"./social-psych-14.yml": [
		464,
		9
	],
	"./social-psych-2.manifest": [
		341,
		3
	],
	"./social-psych-2.manifest.json": [
		341,
		3
	],
	"./social-psych-3.manifest": [
		342,
		3
	],
	"./social-psych-3.manifest.json": [
		342,
		3
	],
	"./social-psych-4.manifest": [
		343,
		3
	],
	"./social-psych-4.manifest.json": [
		343,
		3
	],
	"./social-psych-5.manifest": [
		344,
		3
	],
	"./social-psych-5.manifest.json": [
		344,
		3
	],
	"./social-psych-6.manifest": [
		345,
		3
	],
	"./social-psych-6.manifest.json": [
		345,
		3
	],
	"./social-psych-8.manifest": [
		346,
		3
	],
	"./social-psych-8.manifest.json": [
		346,
		3
	],
	"./sorting-test.yml": [
		465,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1184;
module.exports = webpackAsyncContext;